import type {
  Indicator,
  IndicatorsGroup,
  TagIndicator,
} from "@/pages/human-resources/time-management/business/indicators/Indicators.ts";
import { equivalenceHoraireFromString } from "@/pages/human-resources/time-management/business/indicators/EquivalenceHoraire.ts";
import type { IndicatorsGroupOut } from "@/pages/human-resources/time-management/endpoints/indicators/inout/IndicatorsGroupOut.ts";
import type { IndicatorOut } from "@/pages/human-resources/time-management/endpoints/indicators/inout/IndicatorOut.ts";
import { sortByKey } from "@/shared/utils/Arrays.ts";

export function mapIndicatorsGroups(
  dtos: IndicatorsGroupOut[],
): IndicatorsGroup[] {
  const groups = dtos.map(mapIndicatorsGroup);
  sortByKey(groups, (g) => g.order);
  return groups;
}

function mapIndicatorsGroup(group: IndicatorsGroupOut): IndicatorsGroup {
  const isTagGroup: boolean = group.uid === "com.netresto.rh.temps.core.tag";
  const res: IndicatorsGroup = {
    uid: group.uid,
    order: group.priority,
    label: group.label,
    isTagGroup,
    indicators: [],
  };
  group.indicators.map((i) => res.indicators.push(mapIndicator(res, i)));
  return res;
}

function mapIndicator(group: IndicatorsGroup, indic: IndicatorOut): Indicator {
  const res: Indicator = {
    src: indic.src,
    id: indic.id,
    label: indic.libelle,
    group: group,
  };
  if (!group.isTagGroup) {
    return res;
  }
  return {
    ...res,
    timeSlotCategoryUuid: indic.idTimeSlotCategory,
    equivalenceHoraire: equivalenceHoraireFromString(
      indic.equivalenceHoraireType,
    ),
    obsolete: indic.obsolete,
    isCodeAbsence: indic.isCodeAbsence,
    color: indic.couleur,
  } as TagIndicator;
}
